"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable line-comment-position, no-inline-comments */
var validator = function textInputControlValidator(state, props) {
  var storedValue = state.storedValue;
  var value = storedValue.replace(/ /g, '');
  var defaultPatterns = [/^4[0-9]{12}(?:[0-9]{3})?$/, // Visa
  /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/, // Master Card
  /^3[47][0-9]{13}$/, // Amex
  /^6(?:011|5[0-9]{2})[0-9]{12}$/ // Discover
  ];

  if (props.fieldData.validation.pattern) {
    return new RegExp(props.fieldData.validation.pattern).test(value);
  }

  return defaultPatterns.filter(function (pattern) {
    return pattern.test(value);
  }).length > 0;
};

var _default = validator;
exports["default"] = _default;